import { render, staticRenderFns } from "./SpacerWidget.vue?vue&type=template&id=16ea29c0&"
import script from "./SpacerWidget.vue?vue&type=script&lang=js&"
export * from "./SpacerWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16ea29c0')) {
      api.createRecord('16ea29c0', component.options)
    } else {
      api.reload('16ea29c0', component.options)
    }
    module.hot.accept("./SpacerWidget.vue?vue&type=template&id=16ea29c0&", function () {
      api.rerender('16ea29c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/SpacerWidget.vue"
export default component.exports